import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/nbci/partymaster'
import pathMap from 'src/paths/pathMap'

class NBCIUSCAPartyMasterRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.NBCI_USCA_PARTY_MASTER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.NBCI_USCA_PARTY_MASTER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.NBCI_USCA_PARTY_MASTER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.NBCI_USCA_PARTY_MASTER_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default NBCIUSCAPartyMasterRoute
